interface StatusInProgressIconProps {
  className?: string
}

export const StatusInProgressIcon: React.FC<StatusInProgressIconProps> = ({
  className = "text-white",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      className={className}
    >
      <path
        d="M12.5 22.1001C17.8019 22.1001 22.1 17.8021 22.1 12.5001C22.1 7.19821 17.8019 2.90015 12.5 2.90015"
        stroke="white"
        strokeWidth="1.2"
      />
      <path
        d="M12.4999 22.1C7.19797 22.1 2.8999 17.802 2.8999 12.5C2.8999 7.19809 7.19797 2.90002 12.4999 2.90002"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeDasharray="2.4 2.4"
      />
      <path
        d="M7.4834 12.3976L10.8621 15.7764L17.5168 9.224"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
